import(/* webpackMode: "eager", webpackExports: ["PageLayout"] */ "/vercel/path0/app/layouts/PageLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WorkSkeleton"] */ "/vercel/path0/components/work/WorkSkeleton.tsx");
